<template>
  <div class="">
    <h3>Preparation:</h3>
    <div class="container pt-3 m-auto text-left ">
       
      <form id="form" autocomplete="off" class="form-horizontal" @submit.stop.prevent="validateBeforeSubmit">

        
        <b-row v-if="preparation">
          <b-col cols="12">

            <div class="mt-3">Archivo: {{ preparation.archivo_nombre }}</div>

            <b-form-file v-validate.persist="{ required: true }" name="archivo" required
              v-model="preparation.archivo" 
              :state="!preparation.archivo ? null : (getExtFile(preparation.archivo.name) == 'pdf' ? true : false)"
              placeholder="Elige un archivo o suéltalo aquí..."
              drop-placeholder="Suelta el archivo aquí..." accept=".pdf">
            </b-form-file>

          </b-col>
        </b-row>

        <b-row class="mb-3 mt-2">
          <b-col cols="6">
            <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
          </b-col>
          <b-col cols="6">
            <button class="btn btn-block btn-success" type="submit">Guardar</button>
          </b-col>
        </b-row>
      </form>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'PreparationNuevo',
    components: {
      
    },
    props:{
      tema_id:String,
      preparation: Object
    },
    data () {
      return {
        
      }
    },
    mounted () {
    },
    
    methods:{
        ...mapActions({
            editar: 'temas_adicional/editar',
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      validateBeforeSubmit () {
        if (this.preparation.archivo && this.getExtFile(this.preparation.archivo.name) != "pdf") {
          this.preparation.archivo = null;
        }
        this.$validator.validateAll().then(result => {
          if (!result) {
            console.log('validateBeforeSubmit error')
          } else {
            console.log('validateBeforeSubmit no error')

            const form = new FormData();
            form.append("tema_id", this.tema_id)
            form.append("id", this.preparation.id)
            form.append("tipo", this.preparation.tipo)
            form.append("archivo", this.preparation.archivo, this.preparation.archivo.name)
            
            this.editar(form).then(result =>{
                this.setWarning('Modified preparacion', { root: true }).then(()=>{
                  this.$emit("actualizar")
                  this.cerrar();
              })
            }).catch(error=>{
              //todo probar si se puede quitar
              console.error("Preparacion error result:", error)
            })
          }
        })
      },
      cerrar() {
        this.$emit("cerrar")
      },
      getExtFile(filename) {
        let info = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : undefined;
        if (info && info.length) {
          return info[0];
        }
        return undefined;
      },

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
      }),
      tema() {
        if (this.detalle[this.tema_id]) {
          return this.detalle[this.tema_id];
        }
        return null;
      },
      
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
